// Internal Endpoints for BFF

export const SEARCH_SUGGESTIONS = '/api/search/suggestions';
export const LOCATIONS = '/api/locations';
export const LOCATIONS_INFO_V2 = '/api/locations/v2';
export const SAVED_LISTS = '/api/savedLists';
export const SAVED_LIST_DUPLICATE = '/api/savedLists/duplicateList';
export const DEALER_CUSTOMERS = '/api/dealer-customers/{customerNumber}';
export const DEALER_SEARCH = '/api/dealer-search';
export const DEALER_SEARCH_CUSTOMER = '/api/dealer-search/{customerNumber}';
export const EQUIPMENT_SEARCH_SUGGESTIONS = '/api/equipment/search-suggestions';
export const PLACES = '/api/places';
export const EQUIPMENT_SEARCH = '/api/me/equipment-suggestions';
export const DEALER_INFO = '/api/dealer-info';
export const USER_RESET_SESSION = '/api/user-reset-session';
export const PRICE_AND_AVAILABILITY = '/api/price-and-availability';
export const CART_DETAILS = '/api/cart';
export const CART_ORDER_TOTALS = '/api/cart/order-totals';
export const EXPORT_ORDER = '/api/order/{orderId}/export';
export const SALESFORCE_EMAIL = '/api/order/{orderId}/salesforceEmail';
export const TAX_AND_FREIGHT_API = '/api/tax-and-freight/{orderId}';
export const GET_ATTACHMENT_SUGGESTIONS_API = '/api/get-attachment/suggestions';
export const GET_ATTACHMENT_PRODUCTS_API = '/api/get-attachment/products';
export const GET_ATTACHMENT_EQUIPMENT_FAMILIES_API =
  '/api/get-attachment/equipment-families';
export const BEST_SELLER_API = '/api/product/best-seller';
export const LD_FEATURE_FLAG = '/api/flags';
export const INVOICE_DETAILS_API = '/api/invoices/details/{invoiceNumber}';
export const INVOICE_SUMMARY_API = '/api/product/summary';
export const GET_B2C_TOKEN_API = '/api/get-b2c-token';
export const GET_PMKITS_EQUIPMENT = '/api/pmkits';
export const SALESFORCE_EMAIL_API =
  '/wcs/resources/xorder/v2/salesForceOrderInfo';
export const PRICE_AND_AVAILABILITY_HEADLESS =
  '/api/price-and-availability-headless';
export const APPLY_PROMO_CODE_V2_API = '/api/cart/apply-promo-code';
export const OMM_CONTENT = '/api/omm/contents';
